function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.206 17.233L19.4726 21.633H11.5274L10.794 17.233H20.206ZM24.1015 12.833C24.7812 12.833 25.2983 13.4433 25.1865 14.1138L23.5064 24.1946C23.3296 25.2554 22.4118 26.033 21.3363 26.033H9.66368C8.58823 26.033 7.67042 25.2554 7.49361 24.1946L5.81347 14.1138C5.70173 13.4433 6.21877 12.833 6.89851 12.833H24.1015Z",
  fill: "#ffffff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4861 7.90561C26.5933 7.23797 26.0683 6.63412 25.3807 6.63412H20.8854C20.4412 6.63412 20.039 6.37582 19.8606 5.97591L19.2874 4.69117C19.109 4.29126 18.7069 4.03296 18.2626 4.03296L12.7621 4.03296C12.3179 4.03296 11.9158 4.29126 11.7373 4.69117L11.1642 5.97591C10.9858 6.37582 10.5836 6.63412 10.1394 6.63412H5.61927C4.93168 6.63412 4.40674 7.23797 4.51393 7.90561L4.80276 9.70443C4.88861 10.2391 5.35743 10.6329 5.9081 10.6329H25.0919C25.6426 10.6329 26.1114 10.2391 26.1972 9.70443L26.4861 7.90561Z",
  fill: "#ffffff"
});

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.fdbca20a.svg";
export { ForwardRef as ReactComponent };